import React, { useState } from "react";
import AdminHeader from "../AdminHeader/AdminHeader";
import SideBarAdmin from "../SideBarAdmin/SideBarAdmin";
import BookingsAdmin from "../BookingsAdmin/BookingsAdmin";
import { useDispatch } from "react-redux";
import TableDateCustomers from "../TableDataCustomers/TableDataCustomers";
// import PricingAdminFields from "./PricingAdminFields";

const BookingAdmin = () => {
  const [rightHeader, setRightHeader] = useState(false);

  const dispatch = useDispatch();

  return (
    <>
      <AdminHeader rightHeader={rightHeader} />

      <div className="topSideVehicles">
        <SideBarAdmin
          setRightHeader={setRightHeader}
          rightHeader={rightHeader}
        />
         <div className="vehicleAdminMain">
          <div className="topTextEditAdmVehic">
            You can see the detail about bookings here...
          </div>

          <div className="topTextsVehiclAdmin">
            <div className="topInputBtnSearch">
              <input placeholder="Search Vehicle" className="inputSearchVehic" />
              <button className="btnSearchVehicle">Search</button>
            </div>

          </div>
         <div className="topTableAdminVehicles">

   
         {/* <TableDateCustomers/> */}

         <BookingsAdmin/>
         
         </div>
        </div>

      </div>
    </>
  );
};

export default BookingAdmin;
